/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";

export default function CategoriesBar({
  displayCategories,
  selectedCategory,
  selectedSubCategory,
  handleCategoryClick,
  isMobile,
  isTablet,
  theme
}) {

  return (
    <div style={{ marginBottom: isMobile ? "18px" : "35px" }}>
      <h2 style={{
        margin: 0,
        marginBottom: "20px",
        fontSize: isMobile ? "18px" : "28px",
        fontWeight: "700",
        color: "#2b1b12",
        textAlign: "right"
      }}>
        الأقسام
      </h2>

      {/* Main Categories Row */}
      <div className="categories-scroll-container"
        style={{
          width: "100%",
          overflowX: "auto",
          paddingBottom: "10px",
          marginBottom: "15px",
          display: "flex",
          gap: "10px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <div style={{ display: "flex", gap: "12px" }}>
          {displayCategories.map(cat => (
            <button
              key={`cat-${cat.id}`}
              onClick={() => handleCategoryClick(cat.id)}
              style={{
                padding: isMobile ? "8px 14px" : "12px 24px",
                border: Number(selectedCategory) === Number(cat.id) ? "none" : `1px solid ${theme.primary}22`,
                borderRadius: "15px",
                background: Number(selectedCategory) === Number(cat.id)
                  ? `linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`
                  : "white",
                color: Number(selectedCategory) === Number(cat.id) ? "white" : "#555",
                fontSize: isMobile ? "13px" : "15px",
                fontWeight: "700",
                cursor: "pointer",
                boxShadow: Number(selectedCategory) === Number(cat.id)
                  ? `0 8px 20px ${theme.primary}33`
                  : "none",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                whiteSpace: "nowrap",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
              }}
            >
              <span>{cat.icon}</span>
              <span>{cat.name}</span>
              <span style={{ opacity: 0.7, fontSize: "12px" }}>({cat.count})</span>
            </button>
          ))}
        </div>
      </div>

      {/* Subcategories Row - Only shows if the selected category has subcategories */}
      {(() => {
        const activeCat = displayCategories.find(c => Number(c.id) === Number(selectedCategory));
        if (!activeCat || !activeCat.subCategories || activeCat.subCategories.length === 0) return null;

        return (
          <div
            className="subcategories-scroll-container"
            style={{
              display: "flex",
              gap: "8px",
              overflowX: "auto",
              paddingBottom: "10px",
              paddingRight: "5px",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {activeCat.subCategories.map(sub => (
              <button
                key={`sub-${sub.id}`}
                onClick={() => handleCategoryClick(selectedCategory, sub.id)}
                style={{
                  padding: "8px 18px",
                  border: Number(selectedSubCategory) === Number(sub.id) ? "none" : "1px solid #EEE",
                  borderRadius: "12px",
                  background: Number(selectedSubCategory) === Number(sub.id)
                    ? theme.primary
                    : "#F8F9FA",
                  color: Number(selectedSubCategory) === Number(sub.id) ? "white" : "#666",
                  fontSize: "13px",
                  fontWeight: "600",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  transition: "all 0.2s ease",
                  boxShadow: Number(selectedSubCategory) === Number(sub.id)
                    ? `0 4px 12px ${theme.primary}22`
                    : "none"
                }}
              >
                {sub.name}
                <span style={{ marginRight: "5px", opacity: 0.6, fontSize: "11px" }}>({sub.count})</span>
              </button>
            ))}
          </div>
        );
      })()}
      <style>{`
        .categories-scroll-container::-webkit-scrollbar {
          height: 6px;
        }
        .categories-scroll-container::-webkit-scrollbar-track {
          background: #f2f2f2;
          border-radius: 10px;
        }
        .categories-scroll-container::-webkit-scrollbar-thumb {
          background: ${theme.primary};
          border-radius: 10px;
        }
        .categories-scroll-container::-webkit-scrollbar-thumb:hover {
          background: ${theme.primary}cc;
        }
        .categories-scroll-container {
          scrollbar-color: ${theme.primary} #f2f2f2;
          scrollbar-width: thin;
        }
      `}</style>
    </div>
  );
}
